var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { IBatchStatus, } from '../types/remoteLogs';
const createRemoteLogger = (configuration) => {
    let timer;
    let IS_BATCH_PROCESS_STARTED = IBatchStatus.STOP;
    const _configuration = configuration;
    const REMOTE_LOGS_STORAGE_KEY = 'remoteLogs';
    const FAILED_REMOTE_LOGS_STORAGE_KEY = 'failedRemoteLogs';
    let _isRemoteLogEnabled = _configuration.REMOTE_LOGS_ENABLED;
    const setRemoteLogEnabled = (isRemoteLogEnabled) => (_isRemoteLogEnabled = isRemoteLogEnabled);
    const initializeBatchLogger = () => _startBatchLogger();
    const getLogBatchProcessStatus = () => IS_BATCH_PROCESS_STARTED;
    const setLogBatchProcessStatus = (status) => {
        if (IS_BATCH_PROCESS_STARTED === 'START' && status === 'STOP') {
            cancelBatchLogger();
        }
        else if (IS_BATCH_PROCESS_STARTED === 'STOP' && status === 'START') {
            _startBatchLogger();
        }
        IS_BATCH_PROCESS_STARTED = status;
    };
    const _getLogsFromStorage = (log) => __awaiter(void 0, void 0, void 0, function* () {
        const FAILED_REMOTE_LOGS_SIZE = _configuration.REMOTE_LOGS_SIZE * 2;
        const existingNewRemoteLogs = (yield _configuration.storageProvider.getItem(REMOTE_LOGS_STORAGE_KEY)) ||
            [];
        let failedRemoteLogs = (yield _configuration.storageProvider.getItem(FAILED_REMOTE_LOGS_STORAGE_KEY)) || [];
        _configuration.storageProvider.removeItem(FAILED_REMOTE_LOGS_STORAGE_KEY);
        // If failed logs exceed 2 times the allocated REMOTE_LOGS_SIZE, we assume failure and remove it completely.
        if (failedRemoteLogs.length >= FAILED_REMOTE_LOGS_SIZE) {
            failedRemoteLogs = failedRemoteLogs.slice(0, _configuration.REMOTE_LOGS_SIZE);
        }
        const tmpLogs = [...existingNewRemoteLogs, ...failedRemoteLogs];
        const remoteLogsExist = tmpLogs && tmpLogs.length > 0;
        let remoteLogs = null;
        if (remoteLogsExist) {
            remoteLogs = tmpLogs;
        }
        if (log) {
            remoteLogs = remoteLogs === null ? [log] : [log, ...remoteLogs];
        }
        return remoteLogs;
    });
    const addLog = (log) => __awaiter(void 0, void 0, void 0, function* () {
        if (_isRemoteLogEnabled) {
            setLogBatchProcessStatus(IBatchStatus.START);
            try {
                const existingRemoteLogs = yield _getLogsFromStorage(log);
                _configuration.storageProvider
                    .setItem(REMOTE_LOGS_STORAGE_KEY, existingRemoteLogs)
                    .then(() => {
                    if (existingRemoteLogs.length >= _configuration.REMOTE_LOGS_SIZE) {
                        cancelBatchLogger();
                        processLogs();
                    }
                })
                    .catch((e) => {
                    _configuration.onErrorCallback(e);
                });
            }
            catch (e) {
                _configuration.onErrorCallback(e);
            }
        }
        else {
            _configuration.onLogCallback(`REMOTE_LOGS_ENABLED is set to: ${_isRemoteLogEnabled}`);
        }
    });
    const processLogs = () => __awaiter(void 0, void 0, void 0, function* () {
        if (IS_BATCH_PROCESS_STARTED === IBatchStatus.START) {
            try {
                const remoteLogs = (yield _configuration.storageProvider.getItem(REMOTE_LOGS_STORAGE_KEY)) || [];
                if (remoteLogs && remoteLogs.length > 0) {
                    yield _configuration.storageProvider.removeItem(REMOTE_LOGS_STORAGE_KEY);
                    yield sendLogs(remoteLogs);
                }
                else {
                    setLogBatchProcessStatus(IBatchStatus.STOP);
                }
            }
            catch (error) {
                setLogBatchProcessStatus(IBatchStatus.STOP);
            }
            _resetTimer();
        }
    });
    const sendLogs = (remoteLogs) => __awaiter(void 0, void 0, void 0, function* () {
        if (_isRemoteLogEnabled) {
            const body = {
                date: Date.now(),
                logs: remoteLogs,
            };
            _configuration.httpProvider.postRequest(body).catch((e) => {
                _configuration.onErrorCallback(e);
                _configuration.storageProvider
                    .getItem(FAILED_REMOTE_LOGS_STORAGE_KEY)
                    .then((failedLogs) => {
                    if (failedLogs && failedLogs.length > 0) {
                        failedLogs.unshift(remoteLogs);
                    }
                    _configuration.storageProvider.setItem(FAILED_REMOTE_LOGS_STORAGE_KEY, failedLogs);
                });
            });
        }
        else {
            _configuration.onLogCallback(`REMOTE_LOGS_ENABLED is set to: ${_isRemoteLogEnabled}`);
        }
    });
    const _startBatchLogger = () => {
        timer = setTimeout(() => processLogs(), _configuration.DELAY_BEFORE_SENDING || 30000);
    };
    const cancelBatchLogger = () => clearTimeout(timer);
    const _resetTimer = () => {
        cancelBatchLogger();
        _startBatchLogger();
    };
    return {
        initializeBatchLogger,
        cancelBatchLogger,
        getLogBatchProcessStatus,
        setLogBatchProcessStatus,
        addLog,
        sendLogs,
        setRemoteLogEnabled,
    };
};
export default createRemoteLogger;
